import { inject } from 'vue';
export default class AppUtil {
}
// サーバーのURL生成
AppUtil.cvtRemotePath = (file, dir) => {
    const path = dir ? `${dir}/${file}` : file;
    return `${inject('remoteBaseUrl')}/${path}`;
};
